import { ApexSlotableMixin } from '../../node_modules/@fmr-pr103625/apex-slots/dist/esm2015/utils.js';
import { PvdBaseComponent } from './pvd-base-component.js';

class PvdSlotifyBaseComponent extends ApexSlotableMixin(PvdBaseComponent) {
    hasSlotableContent(slotName = 'default') {
        return super.hasSlotableContent(slotName, {
            ignoreComments: true,
            ignoreWhitespace: true,
        });
    }
    isSlotUsed(slotName = 'default') {
        return this.hasSlotableContent(slotName) || this.hasAssignedSlotContent(slotName);
    }
}

export { PvdSlotifyBaseComponent };
//# sourceMappingURL=pvd-slotify-base-component.js.map
